import React, { useState, useEffect, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, cloneDeep } from "lodash";
import { formFields } from "./constant"; // Import your formFields constant
import Input from "../../../../../components/FormElements/Input";
import ToastModal from "../../../../../components/ToastModal";
import SelectNew from "../../../../../components/FormElements/SelectNew";
import CreatableSelect from "../../../../../components/CreatableSelect";
import { Link, withRouter } from 'react-router-dom';
import routes from '../../../../../routes';
import {
    handleFieldError,
    handleError,
} from "../../../../../utils/form-validation";

import {
    postDataConfigV2Action
} from "../../../../../actions";
import RichTextEditor from 'react-rte';
import { useFetchPlatformData } from "../../../../../hooks/useFetchPlatformData";
import { isApiCallSuccess, isTenantDemoAdvertiser } from "../../../../../selectors";
import { getDataConfigDeatilsv1Action } from "../../../../../actions/dataConfig";
import { message } from "antd";
import { infoMessages } from "../../../../../constants/demo/constant";

const AddDataConfig = (props) => {
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({});
    const [variableName, setVariableName] = useState(null);
    const [variableNamesList, setVariableNamesList] = useState([]);
    const [variableNameErrors, setVariableNameErrors] = useState([]);
    const [bekiAllMappingVariables, setBekiAllMappingVariables] = useState([]);
    const [platformData, setPlatformData] = useState([]);
    const [attributeValues, setAttributeValues] = useState([
        {
            primaryValue: "",
            mappingValue: "",
            valueDisplayText: '',
            errors: {},
            touched: {}
        },
    ]);

    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });

    const [attributeMapping, setAttributeMapping] = useState(null);
    const [modalType, setModalType] = useState('');
    const [richTextValue, setRichTextValue] = useState(RichTextEditor.createEmptyValue());
    const [variableEditId, setVariableEditId] = useState(null);
    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const { match: { params: { id } } } = props;

    const dispatch = useDispatch();

    const isDemoAdvertiser = useMemo(() => {
        return isTenantDemoAdvertiser(tenantId);
    }, [tenantId]);

    const handleAddRow = () => {
        setAttributeValues((prevAttrValues) => [
            ...prevAttrValues,
            {
                primaryValue: "",
                mappingValue: "",
                valueDisplayText: '',
                errors: {},
                touched: {}
            },
        ]);
    };

    const handleDeleteRow = (index) => {
        setAttributeValues((prevAttrValues) => {
            const updatedAttrValues = [...prevAttrValues];
            updatedAttrValues.splice(index, 1);
            return updatedAttrValues;
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[e.target.name] = value;
        if (name == formFields.platform.key) {
            setVariableName(null);
            setVariableNamesList([]);
        }
        setForm(newForm);
    };

    const onRichTextChange = (value) => {
        setRichTextValue(value);
    };

    const handleAttributeChange = (e, index) => {
        const newAttributeValues = [...attributeValues];
        newAttributeValues[index] = {
            ...newAttributeValues[index],
            [e.target.name]: e.target.value
        };
        setAttributeValues(newAttributeValues);
    }

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const handleAttributeTouch = (e, index) => {
        const newAttributeValues = [...attributeValues];
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newAttributeValues[index] = {
            ...newAttributeValues[index],
            [e.target.name]: e.target.value,
            errors: {
                ...newAttributeValues[index].errors,
                [e.target.name]: error
            },
            touched: {
                ...newAttributeValues[index].touched,
                [e.target.name]: true
            }
        };
        setAttributeValues(newAttributeValues);
    };

    const getMappingValuesOptions = (index) => {
        try {
            let optionValues = [];
            if (variableName) {
                let values = variableNamesList.find(item => item.id === variableName.value);
                if (id) {
                    values = variableNamesList.find(item => item.name === variableName.value);
                }
                optionValues = values ? values.list : bekiAllMappingVariables;
            }
            const selectedMappingValues = attributeValues.filter((attribute, aIndex) => aIndex !== index);
            const selectedMappingValueIds = selectedMappingValues.map(item => parseInt(item.mappingValue));
            if (selectedMappingValueIds && selectedMappingValueIds.length > 0) {
                let filteredMappingValues = optionValues.filter(mappingValue => !selectedMappingValueIds.includes(mappingValue.id));
                return filteredMappingValues;
            } else {
                return optionValues;
            }
        } catch (e) {
            console.log(e);
        }
    };

    const resetForm = () => {
        setErrors({});
        setTouched({});
        setSubmited(false);
        setAttributeValues([
            {
                primaryValue: "",
                mappingValue: "",
                valueDisplayText: '',
                errors: {},
                touched: {}
            },
        ]);
        setForm({
            platform: '',
            mappingVariable: ''
        });
    };

    const checkIfPlatformAndVariableMatched = (value) => {
        let check = false;
        if (variableNamesList && variableNamesList.length > 0) {
            let selectedVariable = variableNamesList.find(item => item.id == value);
            if (selectedVariable) {
                check = selectedVariable['mappedPlatformsIdSet'].includes(Number(form[formFields.platform.key]));
            }
            if (!isMapWithBekiValue()) {
                check = true;
            }
        }
        return check;
    };

    const getSelectedPlatformName = () => {
        let name = '';
        if (platformData && platformData.length > 0) {
            let selectedPlatform = platformData.find(item => item.key == form[formFields.platform.key]);
            if (selectedPlatform) {
                name = selectedPlatform.value;
            }
        }
        return name;
    };

    const isMapWithBekiValue = () => {
        let check = false;
        if (platformData && platformData.length > 0) {
            let selectedPlatform = platformData.find(item => item.key == form[formFields.platform.key]);
            if (selectedPlatform && selectedPlatform.value.toLowerCase() !== 'beki') {
                check = true;
            }
        }
        return check;
    };

    const mapAndSetEditVariableId = (selected) => {
        if (!isMapWithBekiValue()) {
            setVariableEditId(selected.value);
        } else {
            let selectedVariableName = variableNamesList.find(variable => variable.id == selected.value);
            let selectedVariableNameMappingDetails = selectedVariableName['mappingDetails'];
            if (selectedVariableNameMappingDetails && selectedVariableNameMappingDetails.length > 0) {
                let filteredVariableNameMappingDetails = selectedVariableNameMappingDetails.find(item => item.platformId == Number(form[formFields.platform.key]));
                if (filteredVariableNameMappingDetails) {
                    setVariableEditId(filteredVariableNameMappingDetails['id']);
                }
            }
        }
    };

    const submitForm = async (id) => {
        let addParams = { addup: 'auto' };
        if (id) {
            addParams = { addup: id };
        }

        let payload = {
            name: variableName.label,
            platformId: parseInt(form.platform),
            isActive: 1,
            list: attributeValues.map(item => ({
                name: item.primaryValue,
                isActive: 1,
                displayName: item.valueDisplayText,
                attributeMapping: Number(item[formFields.mappingValue.key]) ? Number(item[formFields.mappingValue.key]) : null,
                id: item.id
            })),
            description: richTextValue && richTextValue.toString('html') !== '<p><br></p>' ? richTextValue.toString('html') : '',
            displayName: form[formFields.displayText.key] ? form[formFields.displayText.key] : ''
        };

        if (id) {
            payload['id'] = id;
        }

        if (attributeMapping) {
            payload['attributeMapping'] = attributeMapping;
        }

        // if (!variableName.hasOwnProperty('__isNew__') && addParams.addup == 'auto') {
        //     payload[`mappingDetails`] = [{ id: Number(variableName.value) }];
        // }

        await dispatch(postDataConfigV2Action({ tenantId, authToken, userId, params: addParams, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "", msg },
                    response,
                } = data;
                if (isApiCallSuccess(status)) {
                    // console.log(response);
                    // console.log(status);
                    toast(status, msg);
                    resetForm();
                } else {
                    console.log("Unable to add variable!");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const validate = () => {
        let { errors, valid } = handleError(form, { platform: formFields.platform });
        let counter = 0;
        const newAttributeValues = attributeValues.map(attribute => {
            for (const property in attribute) {
                if (property !== 'errors' && property !== 'touched') {
                    let { error, isValid } = handleFieldError(attribute[property], formFields[property]);
                    attribute['errors'][property] = error;
                    if (!isValid) {
                        counter++;
                    }
                }
            }
            return attribute;
        });
        if (variableName == null) {
            setVariableNameErrors({ required: true });
        }
        setErrors(errors);
        setAttributeValues(newAttributeValues);
        setSubmited(true);
        return counter == 0 && valid && variableName != null;
    };

    const handleSubmit = (e) => {

        if (isDemoAdvertiser) {
            if (id) {
                message.info(infoMessages.variableEdit)
            } else {
                message.info(infoMessages.variableAdd)
            }
            return;
        }

        e.preventDefault();
        let valid = validate();
        if (valid) {
            let confirmationMessage = "Please confirm if you'd like to proceed with this action.";
            setModalType(id ? 'edit' : 'add');
            toast('confirmation', confirmationMessage);
        }
    };

    const getAllMapWithBekiVariables = async () => {
        let params = { list: 'mappingChildDropdown' };
        let payload = {};
        await dispatch(postDataConfigV2Action({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (isApiCallSuccess(status) && response && response.length > 0) {
                    setBekiAllMappingVariables(response);
                } else {
                    console.log("Variable not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const editId = async () => {
        if (id) {
            let params = { list: id };
            await dispatch(postDataConfigV2Action({ tenantId, authToken, userId, params }))
                .then(async (data) => {
                    const {
                        responseCode: { status = "" },
                        response,
                    } = data;
                    if (isApiCallSuccess(status) && response && response.length > 0) {
                        const variableData = response[0];
                        const newForm = form;
                        newForm[formFields.platform.key] = variableData['platformId'];
                        newForm[formFields.displayText.key] = variableData['displayName'];
                        setForm(newForm);
                        setVariableName({ value: variableData['name'], label: variableData['name'] });
                        await searchVariableNames(variableData['name']);
                        setRichTextValue(RichTextEditor.createValueFromString(variableData['description'] ? variableData['description'] : '', 'html'));
                        if (variableData && variableData.list && variableData.list.length > 0) {
                            let attributeList = variableData.list.map(item => {
                                return (
                                    {
                                        id: item.id,
                                        primaryValue: item.name,
                                        mappingValue: (item.mappingDetails && item.mappingDetails.length > 0) ? item.mappingDetails[0]['id'] : '',
                                        valueDisplayText: item.displayName,
                                        errors: {},
                                        touched: {}
                                    }
                                );
                            });
                            setAttributeValues(attributeList);
                        }
                    } else {
                        console.log("Variable not found");
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const toast = (status, msg, type) => {
        setToastModal({
            enableToast: true,
            toastStatus: status,
            toastMsg: msg
        });
        return;
    }

    const handleToastStatus = async (status) => {
        setToastModal({
            ...toastModal,
            enableToast: status
        });
    };

    const confirmationCallbackModel = () => {
        const { history, match } = props;
        setToastModal({
            ...toastModal,
            enableToast: false
        });
        if (modalType == 'add') {
            submitForm();
        } else if (modalType == 'edit') {
            submitForm(id);
        } else {
            history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.containers.dataConfig}/${routes.dataConfig.variables.name}/${routes.dataConfig.variables.editVariables}/${variableEditId}`);
            window.location.reload();
        }
    };

    const searchVariableNames = _.debounce(async (inputValue) => {
        let params = { list: 'nameList' };
        let bekiPlatformId = platformData.find(platform => platform.value.toLowerCase() == "beki");
        if (bekiPlatformId) {
            bekiPlatformId = bekiPlatformId.key;
        }
        let payload = {
            platform: [Number(bekiPlatformId)],
            name: inputValue
        };
        await dispatch(postDataConfigV2Action({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (isApiCallSuccess(status) && response && response.length > 0) {
                    setVariableNamesList(response);
                } else {
                    setVariableNamesList([]);
                    // console.log("Variable Name List Not Found!");
                }
            })
            .catch((error) => {
                console.error(error);
            })
    }, 300);

    const initialize = async () => {
        if (id) {
            await editId();
        }
        await getAllMapWithBekiVariables();
    };

    useEffect(() => {
        async function fetchPlatformDetails() {
            const params = { list: "all", type: "platform" };

            await dispatch(getDataConfigDeatilsv1Action({ tenantId, authToken, userId, params }))
                .then((data) => {
                    const {
                        responseCode: { status = "" },
                        response,
                    } = data;
                    if (isApiCallSuccess(status) && response && response.length > 0) {
                        setPlatformData(response);
                    } else {
                        setPlatformData([]);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
        fetchPlatformDetails();
    }, [])

    useEffect(() => {
        if (platformData && platformData.length > 0) {
            initialize();
        }
    }, [platformData]);

    return (
        <>
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    path={routes.containers.admin + '/' + routes.containers.dataConfig + '/' + routes.dataConfig.variables.name}
                    idProps={props}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    poc={false}
                    outSideClickEnable={false}
                />
            }
            <div className="main-panel ion">
                <div className="content-wrapper">
                    <div className="row mt-3 px-4">
                        <div className="col-md-12">
                            <SelectNew
                                onChange={handleChange}
                                onBlur={handleTouch}
                                value={form[formFields.platform.key]}
                                setting={formFields[formFields.platform.key]}
                                error={errors[formFields.platform.key]}
                                submited={submited}
                                touched={touched[formFields.platform.key]}
                                options={platformData}
                                disabled={id ? true : false}
                            />
                        </div>
                    </div>

                    <div className="row mt-1 px-4">
                        <div className="col-md-6 pt-2">
                            <div className="form-group row">
                                <label for={`name`} class="col-12 col-form-label pt-0">
                                    Variable Name<span className="text-danger">*</span> <br />
                                </label>
                                <CreatableSelect
                                    options={variableNamesList.map(item => ({ value: item.id, label: item.name }))}
                                    onChange={(selected) => {
                                        if (selected['__isNew__']) {
                                            setVariableName(selected);
                                            setVariableNameErrors([]);
                                        } else {
                                            if (checkIfPlatformAndVariableMatched(selected.value)) {
                                                setModalType(null);
                                                setVariableName(null);
                                                mapAndSetEditVariableId(selected);
                                                setVariableNamesList([]);
                                                setVariableNameErrors([]);
                                                toast('confirmation', `A variable for this already exists in ${getSelectedPlatformName()}. Would you like to modify it?`);
                                            } else {
                                                setVariableName(selected);
                                                setAttributeMapping(selected.value);
                                            }
                                        }
                                    }}
                                    onInputChange={(inputValue, actionMeta) => {
                                        if (actionMeta.action == 'input-change' && inputValue.length > 3) {
                                            searchVariableNames(inputValue);
                                        } else {

                                        }
                                    }}
                                    value={variableName}
                                    onBlur={(e) => {
                                        if (variableName == null)
                                            setVariableNameErrors({ required: true });
                                    }}
                                    errors={variableNameErrors}
                                    disabled={id ? true : false}
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <Input
                                onChange={(e) => handleChange(e)}
                                onBlur={(e) => handleTouch(e)}
                                value={form[formFields.displayText.key]}
                                setting={formFields[formFields.displayText.key]}
                                error={errors[formFields.displayText.key]}
                                submited={submited}
                                touched={touched[formFields.displayText.key]}
                            />
                        </div>
                    </div>

                    <div className="row mt-1 px-4">
                        <div className="col-md-12">
                            <div className="form-group row">
                                <label for={`name`} class="col-12 col-form-label pt-0">
                                    Variable Info Text:
                                </label>
                                <div className="px-2">
                                    <RichTextEditor
                                        rootStyle={{
                                            fontFamily: "Poppins"
                                        }}
                                        value={richTextValue}
                                        onChange={(value) => onRichTextChange(value)}
                                        toolbarClassName="rte-editor-toolbar"
                                        editorClassName="rte-editor-toolbar"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group row">
                        {attributeValues.map((attribute, index) => (
                            <div
                                key={index}
                                className="form-group row my-2 ml-2 position-relative"
                            >
                                <div className={isMapWithBekiValue() ? `col-md-3` : `col-md-5`}>
                                    <Input
                                        indexForMultipleRender={index}
                                        onChange={(e) => handleAttributeChange(e, index)}
                                        onBlur={(e) => handleAttributeTouch(e, index)}
                                        value={attribute[formFields.primaryValue.key]}
                                        setting={formFields[formFields.primaryValue.key]}
                                        error={attribute[`errors`][formFields.primaryValue.key]}
                                        submited={submited}
                                        touched={attribute[`touched`][formFields.primaryValue.key]}
                                    />
                                </div>

                                <div className={isMapWithBekiValue() ? `col-md-4` : `col-md-5`}>
                                    <Input
                                        indexForMultipleRender={index}
                                        onChange={(e) => handleAttributeChange(e, index)}
                                        onBlur={(e) => handleAttributeTouch(e, index)}
                                        value={attribute[formFields.valueDisplayText.key]}
                                        setting={formFields[formFields.valueDisplayText.key]}
                                        error={attribute[`errors`][formFields.valueDisplayText.key]}
                                        submited={submited}
                                        touched={attribute[`touched`][formFields.valueDisplayText.key]}
                                    />
                                </div>

                                {
                                    isMapWithBekiValue() &&
                                    <div className="col-md-4">
                                        <SelectNew
                                            onChange={(e) => handleAttributeChange(e, index)}
                                            onBlur={(e) => handleAttributeTouch(e, index)}
                                            value={attribute[formFields.mappingValue.key]}
                                            setting={formFields[formFields.mappingValue.key]}
                                            error={attribute[`errors`][formFields.mappingValue.key]}
                                            submited={submited}
                                            touched={attribute[`touched`][formFields.mappingValue.key]}
                                            options={getMappingValuesOptions(index)}
                                        />
                                    </div>
                                }

                                {index != 0 ? (
                                    <div className={isMapWithBekiValue() ? `col-md-1` : `col-md-2`}>
                                        <button
                                            className="btn btn-danger delete-circular-btn"
                                            onClick={() => handleDeleteRow(index)}
                                            style={{ right: "20%" }}
                                        >
                                            <i className="mdi mdi-delete mr-0"></i>
                                        </button>
                                    </div>
                                )
                                    :
                                    <div className={isMapWithBekiValue() ? `col-md-1` : `col-md-2`}>
                                        <button
                                            className="btn btn-primary delete-circular-btn"
                                            onClick={() => handleAddRow()}
                                            style={{ right: "20%" }}
                                        >
                                            <i className="mdi mdi-plus mr-0"></i>
                                        </button>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-12 mt-4">
                            <center>
                                <button type="submit" onClick={handleSubmit} className="btn btn-primary mx-4">Save</button>
                                {' '}
                                {' '}
                                <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.containers.dataConfig}/${routes.dataConfig.variables.name}`}><button type="button" className="btn btn-secondary">Cancel</button></Link>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default withRouter(AddDataConfig);